/*
 * Copyright 2020 Thomer Gil [https://thomer.com/games/brickbreaker-js/]
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
// {{{ imports
import * as ex from 'excalibur';
import { Game } from './game';
import { PauseScene } from './pausescene';
// }}}

// https://groups.google.com/forum/#!topic/excaliburjs/wJSf2CpTMKo
export class GameScene extends ex.Scene {
    // {{{ members, constructors
    private _pauseScene: PauseScene;

    constructor(pauseScene: PauseScene) {
        super();
        this._pauseScene = pauseScene;
    }
    // }}}

    private _pauseKeyPressed = false;
    private _keyListenerAdded = false;

    onInitialize() {
        this._addKeyListener();
    }

    onActivate() {
        this._addKeyListener();
    }

    private _addKeyListener() {
        if (this._keyListenerAdded) return;
        this._keyListenerAdded = true;
        // Use native event listener to detect mapped key (not physical key)
        // This respects keyboard layouts like Dvorak
        window.addEventListener('keydown', (e) => {
            // Only handle if this scene is currently active
            if (!this.isCurrentScene()) return;
            if (e.key.toLowerCase() === 'p' && !e.repeat) {
                this._pauseKeyPressed = true;
            }
        });
    }

    // {{{ public
    public update(engine: Game, delta: number): void {
        super.update(engine, delta);

        if (this._pauseKeyPressed) {
            this._pauseKeyPressed = false;
            this.pause();
        }
    }

    public pause(): void {
        this._pauseScene.bgSceneToRender = this;
        Game.Instance().pause();
    }
    // }}}
}
